export default __webpack_public_path__ + "7fc323b9a9c64f8f033599a204b4a961.png";